import logo from './logo.svg';
import './App.css';
import { HashRouter, BrowserRouter, Routes, Route } from "react-router-dom";

import LandingPage from './pages/LandingPage';
import ZygoSecAbout from './pages/About';
import ZygoSecPrivacy from './pages/Privacy.js';
import ZygoSecBlogPost from './pages/BlogPost.js';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />}></Route>
        <Route path="/privacy" element={<ZygoSecPrivacy />}></Route>
        <Route path="/about" element={<ZygoSecAbout />} />
        <Route path="/blog" element={<ZygoSecBlogPost /> } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
